module.exports = __webpack_public_path__ + "static/icon-check.4a3ffc8d.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-check.png
// module id = 285
// module chunks = 2